import { render, staticRenderFns } from "./TargetSelection.vue?vue&type=template&id=4b0505b9&scoped=true&"
import script from "./TargetSelection.vue?vue&type=script&lang=js&"
export * from "./TargetSelection.vue?vue&type=script&lang=js&"
import style0 from "./TargetSelection.vue?vue&type=style&index=0&id=4b0505b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0505b9",
  null
  
)

export default component.exports